// test935
(935 && 0);
